// @ts-nocheck
import classNames from 'clsx'
import { InferProps } from 'prop-types'
import * as React from 'react'

import { ImageRowProps } from 'views/components/molecules/ImageRow/types'
import ProductImage from 'views/components/organisms/ProductImage'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import 'views/components/molecules/ImageWithDiscountBadge/ImageWithDiscountBadge.scss'

import 'views/components/organisms/ProductImage/ProductImage.scss'
import './ImageRow.scss'

export type PropTypes = InferProps<typeof ImageRowProps>

const ImageRow: React.FunctionComponent<PropTypes> = ({
  items,
  keepImageSize,
}: PropTypes): React.ReactElement => {
  const imageContainerClasses = classNames(
    'u-margin-small--right u-margin-small--bottom',
    {
      'm-remainingImage-box': keepImageSize,
    }
  )

  return (
    <div className="a-list-reset m-imageRow l-flex l-flex--wrap">
      {items.map(item => (
        <div
          key={`DeliveryCostModalGroupEntryItem-${item.id}`}
          className={imageContainerClasses}
          style={{ width: '60px' }}
        >
          <ProductImage
            imageUrl={item.imageUrl}
            name={item.name}
            srcHeight={60}
            srcWidth={60}
            productImageBackgroundDark
          />
        </div>
      ))}
    </div>
  )
}

ImageRow.propTypes = ImageRowProps

export default withShopAndRuntimeConfig(ImageRow)
